/**
 * @generated SignedSource<<f478afd43304485637006a062c7f39cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SalesforceUpdateRecordsInput = {
  clientMutationId?: string | null;
  recordsChanges: ReadonlyArray<SalesforceRecordObjectUpdate>;
};
export type SalesforceRecordObjectUpdate = {
  fields: ReadonlyArray<SalesforceRecordFieldUpdate>;
  objectName: string;
  recordId: string;
};
export type SalesforceRecordFieldUpdate = {
  name: string;
  value: string;
};
export type SalesforceUpdateRecordsMutation$variables = {
  input: SalesforceUpdateRecordsInput;
};
export type SalesforceUpdateRecordsMutation$data = {
  readonly salesforceUpdateRecords: {
    readonly updatedRecords: ReadonlyArray<{
      readonly errors: ReadonlyArray<{
        readonly message: string;
      }> | null;
      readonly fieldName: string | null;
      readonly objectName: string;
      readonly success: boolean | null;
    } | null> | null;
  } | null;
};
export type SalesforceUpdateRecordsMutation = {
  response: SalesforceUpdateRecordsMutation$data;
  variables: SalesforceUpdateRecordsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SalesforceUpdateRecordsPayload",
    "kind": "LinkedField",
    "name": "salesforceUpdateRecords",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SalesforceRecordUpdateResponse",
        "kind": "LinkedField",
        "name": "updatedRecords",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesforceRecordUpdateError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "objectName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fieldName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceUpdateRecordsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesforceUpdateRecordsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8f310ec5736098f80a823f06a4f88632",
    "id": null,
    "metadata": {},
    "name": "SalesforceUpdateRecordsMutation",
    "operationKind": "mutation",
    "text": "mutation SalesforceUpdateRecordsMutation(\n  $input: SalesforceUpdateRecordsInput!\n) {\n  salesforceUpdateRecords(input: $input) {\n    updatedRecords {\n      success\n      errors {\n        message\n      }\n      objectName\n      fieldName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a12c90441196678f4fbc9ad9c317343";

export default node;
